function isFrance(pays) {
  return pays === "FR";
}

module.exports = {
  isFrance,
};
